/**
*
* RedImage
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import defaultTextValues from './defaultTextValues';

import Wrapper from 'components/Templates/dynamics/Wrapper';

class RedImage extends React.PureComponent {


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
    } = this.props;

    return (
      <Wrapper
        {...commonProps}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            typeOfStyle={'sectionTitle'}
            defaultValues={defaultTextValues}
            type={'text'}
            editorData={
              {
                editorType: 'sectionTitle',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'paragraph'}
            type={'text'}
            editorData={
              {
                editorType: 'paragraph',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'imageGalleryWrapper'}
            editorData={
              {
                editorType: 'imageGalleryWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              typeOfStyle={'imageWrapper'}
              editorData={
                {
                  editorType: 'imageWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                typeOfStyle={'imageOneWrapper'}
                editorData={
                  {
                    editorType: 'imageOneWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'imageOne'}
                  editorData={
                    {
                      editorType: 'imageOne',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'imageOneHeader'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'imageOneHeader',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'imageOneParagraph'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'imageOneParagraph',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
              </Wrapper>
            </Wrapper>
            <Wrapper
              {...commonProps}
              typeOfStyle={'imageWrapper'}
              editorData={
                {
                  editorType: 'imageWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                typeOfStyle={'imageTwoWrapper'}
                editorData={
                  {
                    editorType: 'imageTwoWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'imageTwo'}
                  editorData={
                    {
                      editorType: 'imageTwo',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'imageTwoHeader'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'imageTwoHeader',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                {...commonProps}
                typeOfStyle={'imageTwoParagraph'}
                defaultValues={defaultTextValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'imageTwoParagraph',
                    ...commonData
                  }
                }
              >
              </Wrapper>
              </Wrapper>
            </Wrapper>
            <Wrapper
              {...commonProps}
              typeOfStyle={'imageWrapper'}
              editorData={
                {
                  editorType: 'imageWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                typeOfStyle={'imageThreeWrapper'}
                editorData={
                  {
                    editorType: 'imageThreeWrapper',
                    ...commonData
                  }
                }
              >
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'imageThree'}
                  editorData={
                    {
                      editorType: 'imageThree',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'imageThreeHeader'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'imageThreeHeader',
                      ...commonData
                    }
                  }
                >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'imageThreeParagraph'}
                  defaultValues={defaultTextValues}
                  type={'text'}
                  editorData={
                    {
                      editorType: 'imageThreeParagraph',
                      ...commonData
                    }
                  }
                >
                </Wrapper>
                </Wrapper>
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );


  }
}

RedImage.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
};

export default RedImage;
